import { render, staticRenderFns } from "./SettingsSidemenu.vue?vue&type=template&id=aa08c5c4&scoped=true&"
import script from "./SettingsSidemenu.vue?vue&type=script&lang=js&"
export * from "./SettingsSidemenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSidemenu.vue?vue&type=style&index=0&id=aa08c5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa08c5c4",
  null
  
)

export default component.exports